var render = function render(){var _vm=this,_c=_vm._self._c;return _c('z-snackbar',{attrs:{"data-cy":"snackbar","right":_vm.$vuetify.breakpoint.mdAndUp,"color":_vm.color,"opened":_vm.isVisible,"confirmation-text":_vm.confirmationText || undefined,"confirmation":'ok' !== '',"text":_vm.message},on:{"click":_vm.confirmNotification}})
}
var staticRenderFns = []

export { render, staticRenderFns }